import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import LanguageSwitcher from "../../language/components/LanguageSwitcher";
import Offcanvas from "./Offcanvas";
import SearchPanel from "./searchPanel/SearchPanel";
import {
  openHeaderActionsOffcanvas,
  closeHeaderActionsOffcanvas,
  setActiveHeaderActionsOffcanvasTab,
  selectIsHeaderActionsOffcanvasOpen,
  selectActiveHeaderActionsOffcanvasTab,
  type HeaderOffcanvasTab,
} from "../../headerUiSlice";
import type { AppDispatch } from "../../../../app/store";

const SearchIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="header-action-icon search-icon"
  >
    <circle cx="11" cy="11" r="8"></circle>
    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
  </svg>
);

const HeaderActionsContainer: React.FC = () => {
  const { t, ready: translationsReady } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const isOffcanvasOpen = useSelector(selectIsHeaderActionsOffcanvasOpen);
  const activeTab = useSelector(selectActiveHeaderActionsOffcanvasTab);

  const handleOpenOffcanvas = (tab: HeaderOffcanvasTab) => {
    dispatch(openHeaderActionsOffcanvas(tab));
  };

  const handleCloseOffcanvas = () => {
    dispatch(closeHeaderActionsOffcanvas());
  };

  const handleSetActiveTab = (tab: HeaderOffcanvasTab) => {
    dispatch(setActiveHeaderActionsOffcanvasTab(tab));
  };

  if (!translationsReady) {
    return null;
  }

  return (
    <>
      <div className="header-actions">
        {/* Search Button */}
        <button
          className="header-action-button"
          aria-label={t("common.search")}
          onClick={() => handleOpenOffcanvas("search")}
        >
          <SearchIcon />
        </button>

        {/* Language Switcher remains outside */}
        <LanguageSwitcher className="header-language-switcher" />
      </div>

      {/* Offcanvas Component */}
      <Offcanvas
        isOpen={isOffcanvasOpen}
        onClose={handleCloseOffcanvas}
        activeTab={activeTab}
        onTabClick={handleSetActiveTab}
      >
        {/* Content based on active tab */}
        <div
          id="offcanvas-search-panel"
          role="tabpanel"
          aria-labelledby="offcanvas-search-tab"
          hidden={activeTab !== "search"}
          className="offcanvas-panel-content"
        >
          <SearchPanel onClose={handleCloseOffcanvas} />
        </div>
        {/* The cart panel div is removed */}
      </Offcanvas>
    </>
  );
};

export default HeaderActionsContainer;
